import { ErrorBar } from './ErrorBar'
import { InfoBar } from './InfoBar'
import { SystemBar } from './SystemBar'

export const NotificationBars = () => {
  const url = window.location.pathname?.split('/')
  const shouldShowInfoBar =
    url.includes('projekt') || url.includes('projektprognos')

  return (
    <>
      <ErrorBar />

      {shouldShowInfoBar ? <InfoBar /> : undefined}

      <SystemBar />
    </>
  )
}
